import { render } from "./PropertyCategoriesFilter.vue?vue&type=template&id=045d89c1&ts=true"
import script from "./PropertyCategoriesFilter.vue?vue&type=script&lang=ts"
export * from "./PropertyCategoriesFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__